<div class="thumbnail-container" title="Preview of Link URL">
  <div class="thumbnail">
    <iframe [src]="src" frameborder="0" onload="this.style.opacity = 1" alt="Preview unavailable"></iframe>
  </div>
</div>
